import { QUERY_PARAM_PAGE } from '@bluheadless/ui-logic/src/constants'

export const getCatalogPageSize = ({ categoryId, page, defaultPageSize, pagination = [] }) => {
	if (categoryId) {
		const categoryPagination = pagination.find(
			(pageConfig) =>
				(page > 1 ? pageConfig.page === '1+' : pageConfig.page === '1') &&
				(pageConfig.categoryIds.includes(categoryId) || pageConfig.categoryIds.includes('ALL'))
		)

		return categoryPagination ? parseInt(categoryPagination.pageSize) : defaultPageSize
	} else {
		return defaultPageSize
	}
}

export const getCatalogPagesCount = ({ categoryId, productsCount, defaultPageSize, pagination }) => {
	if (categoryId) {
		const pageSizeOne = getCatalogPageSize({ categoryId, page: 1, defaultPageSize, pagination })
		const pageSizeOthers = getCatalogPageSize({ categoryId, page: 2, defaultPageSize, pagination })

		const productsCountFromSecondPage = productsCount - pageSizeOne

		if (productsCountFromSecondPage > 0) {
			return Math.ceil(productsCountFromSecondPage / pageSizeOthers) + 1
		} else {
			return 1
		}
	} else {
		return Math.ceil(productsCount / defaultPageSize) || 1
	}
}

export const getCatalogOffset = ({ categoryId, page, defaultPageSize, pagination }) => {
	let offset = 0

	for (let p = 1; p < page; p++) {
		offset += getCatalogPageSize({ categoryId, page: p, defaultPageSize, pagination })
	}

	return offset
}

export const getCanonicalUrl = ({ canonical: defaultCanonical, page, lastPage, entityType }) => {
	const possibleEntities = ['category', 'macro-category']

	if (!possibleEntities.includes(entityType)) {
		return {
			canonical: defaultCanonical,
			prev: null,
			next: null,
		}
	} else {
		const prevPage = page > 1 ? page - 1 : null
		const nextPage = page < lastPage ? page + 1 : null
		const currentPage = page === 1 ? null : page

		const canonical = currentPage ? `${defaultCanonical}?${QUERY_PARAM_PAGE}=${currentPage}` : defaultCanonical
		const prev = prevPage
			? prevPage === 1
				? defaultCanonical
				: `${defaultCanonical}?${QUERY_PARAM_PAGE}=${prevPage}`
			: null
		const next = nextPage ? `${defaultCanonical}?${QUERY_PARAM_PAGE}=${nextPage}` : null

		return {
			canonical,
			prev,
			next,
		}
	}
}

export const getMetaRobots = ({ robots, page, entityType }) => {
	const possibleEntities = ['category', 'macro-category', 'global-catalog']

	if (!possibleEntities.includes(entityType)) {
		return robots
	} else {
		// BLUHEAD-921: prevent indexing with pagination
		const index = 'noindex'
		const follow = robots.toLowerCase().includes('nofollow') ? 'nofollow' : 'follow'

		const metaRobots = page === 1 ? robots : `${index},${follow}`

		return metaRobots
	}
}
